import { color } from "../Utils/Constant";
import mobile from "../Assets/Contact_icons/mobile.png";
import email from "../Assets/Contact_icons/email.png";
import telephone from "../Assets/Contact_icons/phone.png";
import Address from "../Assets/Contact_icons/address.png";
import Website from "../Assets/Contact_icons/website.png";
import skype from "../Assets/Contact_icons/skype.png";
import facebook from "../Assets/Contact_icons/facebook.png";
import instagram from "../Assets/Contact_icons/instagram.png";
import WhatsApp from "../Assets/Contact_icons/whatsapp.png";
import sms from "../Assets/Contact_icons/sms.png";
const cardLink = "https://nfc.dhanamtechnologiesbh.com/";

export const ContactData = [
  {
    id: 1,
    name: "Mobile",
    icon: mobile,
    details: "+973 3546 3965",
    color: color.primary,
    url: "tel:+973 3546 3965",
  },
  {
    id: 2,
    name: "Email",
    icon: email,
    details: "satheeshkumar@dlktech.co.in",
    color: "#ef233c",
    url: "mailto:satheeshkumar@dlktech.co.in",
  },
  {
    id: 3,
    name: "Telephone",
    icon: telephone,
    details: "+973 3983 5537",
    color: "#4361ee",
    url: "tel:+973 3983 5537",
  },
  {
    id: 4,
    name: "Communication Address",
    icon: Address,
    details:
      "DHANAM TECHNOLOGIES W.L.L, CR - 171219 - 1, Flat No: 1653, Building No: 1565, Road No: 1722, Block No:317, Town: Diplomatic Area, Manama Municipality, Kingdom of Bahrain",
    color: "#ffbc42",
    url: "https://maps.app.goo.gl/gKsUub18Apoq6Qkt8",
  },
  {
    id: 5,
    name: "Website",
    icon: Website,
    details: "www.dhanamtechnologiesbh.com",
    color: "#6e44ff",
    url: "https://dhanamtechnologiesbh.com/",
  },
  {
    id: 6,
    name: "Skype",
    icon: skype,
    details: "satheeshkumar_16",
    color: "#00b5ee",
    url: "skype:satheeshkumar_16",
  },
  {
    id: 7,
    name: "Facebook",
    icon: facebook,
    details: "Dhanam Technologies - Bahrain",
    color: "#4867aa",
    url: "https://www.facebook.com/dhanamtechnologies",
  },
  {
    id: 8,
    name: "Instagram",
    icon: instagram,
    details: "Dhanam Technologies - Bahrain",
    color: "#c7478c",
    url: "https://www.instagram.com/dhanam_technologies/",
  },
];
export const ShareDetailsData = [
  {
    id: 1,
    icon: WhatsApp,
    text: "Share via WhatsApp",
    url: `https://wa.me/?text=${encodeURIComponent(cardLink)}`,
  },
  {
    id: 2,
    icon: sms,
    text: "Share via SMS",
    url: `sms:?body=${encodeURIComponent(cardLink)}`,
  },
  {
    id: 3,
    icon: email,
    text: "Share via Email",
    url: `mailto:?subject=Check this card&body=${encodeURIComponent(cardLink)}`,
  },
  {
    id: 4,
    icon: facebook,
    text: "Share via Facebook",
    url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      cardLink
    )}`,
  },
  {
    id: 5,
    icon: instagram,
    text: "Share via Instagram",
    url: `https://www.instagram.com/accounts/login/?source=logged_out_sem`,
  },
];
